import { render } from "./ManageAccounts.vue?vue&type=template&id=d1937f52"
import script from "./ManageAccounts.vue?vue&type=script&lang=js"
export * from "./ManageAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__